module.exports = __webpack_public_path__ + "media/images/loc_marital_information-027a3c97.png";